import type { ButtonType } from "./constants";

const BUTTON_TYPE_VALUES = ["primaryButton", "secondaryButton", "customButton"];

export const isButtonType = (type: string): type is ButtonType =>
  BUTTON_TYPE_VALUES.includes(type);
